//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfQuantitySelector from "../../atoms/SfQuantitySelector/SfQuantitySelector.vue";

import { useUiNotification } from "~/composables";
import { CMSNotificationType } from "~/helpers/extractCMSNotificationMessage";
import { getCMSLabels } from "~/helpers/globalLabels";

export default {
  name: "SfAddToCart",
  components: {
    SfButton,
    SfQuantitySelector,
  },
  model: {
    prop: "qty",
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    qty: {
      type: [Number, String],
      default: 1,
    },
    hideAddToCart: {
      type: Boolean,
      default: false
    },
    maxQty: {
      type: [Number, String],
      default: 100
    },
    minQty: {
      type: [Number, String],
      default: 1,
    },
    productName: String,
    limitErrorMessage: String,
  },
  setup(props){
    const { send: sendNotification } = useUiNotification();
    const quantityMaxLimitReachedError = getCMSLabels('maximum-number');
    const quantityMinLimitReachedError = getCMSLabels('minimum-number');

    const showMaxQuantityError = (error) => {
      const errorMessage = error == 'minQtyReached' ?  quantityMinLimitReachedError.replace('{0}', props.minQty) : quantityMaxLimitReachedError.replace('{0}', props.maxQty);

      sendNotification({
        type: CMSNotificationType.ERROR,
        message: errorMessage,
        title: props.productName ?? '',
      });
    }

    return {
      showMaxQuantityError
    }
  }
};
